var exports = {
  "p": "xdbfd91f1--4fa19b--info",
};

module.exports = exports;
